// serviceSaga.ts

import { call, put, select, takeLatest } from 'redux-saga/effects';

import { API } from '../../api';
import {
  createServiceTemplate,
  createServiceTemplateFailure,
  createServiceTemplateSuccess,

  getFilteredServiceTemplates,
  getFilteredServiceTemplatesFailure,
  getFilteredServiceTemplatesSuccess,

  getServiceTemplates,
  getServiceTemplatesFailure,
  getServiceTemplatesSuccess,

  removeServiceTemplate,
  removeServiceTemplateFailure,
  removeServiceTemplateSuccess,

  updateServiceTemplate,
  updateServiceTemplateFailure,
  updateServiceTemplateSuccess,
} from '../reducers/serviceTemplatesSlice';

import { errorHandler } from './common';

function* getServiceTemplatesSaga() {
  try {
    // @ts-ignore
    const token = yield select(state => state.auth.token);
    // @ts-ignore
    const response = yield call<any>(API.get, '/studios/services', {
      params: {
        limit: '500',
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    yield put(getServiceTemplatesSuccess(response.data.data));
  } catch (error: any) {
    yield errorHandler({
      error,
      *recallCallback() {
        yield getServiceTemplates();
      },
      *callback() {
        yield put(getServiceTemplatesFailure(error));
      },
    });
  }
}

function* getFilteredServiceTemplatesSaga(action: any) {
  try {
    const searchParams = action.payload;
    // @ts-ignore
    const token = yield select(state => state.auth.token);
    // @ts-ignore
    const response = yield call<any>(API.get, '/studios/services', {
      params: {
        limit: '500',
        ...searchParams,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    yield put(getFilteredServiceTemplatesSuccess(response.data.data));
  } catch (error: any) {
    yield errorHandler({
      error,
      *recallCallback() {
        yield getFilteredServiceTemplatesSaga(action);
      },
      *callback() {
        yield put(getFilteredServiceTemplatesFailure(error));
      },
    });
  }
}

interface createServiceTemplateSagaProp {
  payload: {
    title: string;
    image: string;
    duration: number;
    priceList: any;
    categories?: any;
    onSuccess: () => void;
    onFailure: (error: any) => void;
  };
}

function* createServiceTemplateSaga({
  payload: { title, image, duration, priceList, categories, onSuccess, onFailure },
}: createServiceTemplateSagaProp) {
  try {
    // @ts-ignore
    const token = yield select(state => state.auth.token);
    // @ts-ignore
    yield call<any>(
      API.post,
      `/service-templates`,
      {
        title,
        image,
        duration,
        priceList,
        categories: categories || undefined,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    yield put(createServiceTemplateSuccess());
    onSuccess();
  } catch (error: any) {
    yield errorHandler({
      error,
      *recallCallback() {
        yield createServiceTemplateSaga({
          payload: {
            title,
            image,
            duration,
            priceList,
            categories,
            onSuccess,
            onFailure,
          },
        });
      },
      *callback() {
        yield put(createServiceTemplateFailure(error));
        onFailure(error);
      },
    });
  }
}

interface updateServiceTemplateSagaProp {
  payload: {
    serviceId: string;
    title?: string;
    image?: string;
    duration?: number;
    priceList?: any;
    categories?: any;
    onSuccess: () => void;
    onFailure: (error: any) => void;
  };
}

function* updateServiceTemplateSaga({
  payload: { serviceId, title, image, duration, priceList, categories, onSuccess, onFailure },
}: updateServiceTemplateSagaProp) {
  try {
    // @ts-ignore
    const token = yield select(state => state.auth.token);
    // @ts-ignore
    yield call<any>(
      API.patch,
      `/service-templates/${serviceId}`,
      {
        title,
        image,
        duration,
        priceList,
        categories,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    yield put(updateServiceTemplateSuccess());
    onSuccess();
  } catch (error: any) {
    yield errorHandler({
      error,
      *recallCallback() {
        yield updateServiceTemplateSaga({
          payload: {
            serviceId,
            title,
            image,
            duration,
            priceList,
            categories,
            onSuccess,
            onFailure,
          },
        });
      },
      *callback() {
        yield put(updateServiceTemplateFailure(error));
        onFailure(error);
      },
    });
  }
}

interface removeServiceTemplateSagaProp {
  payload: {
    serviceId: any;
    onSuccess: () => void;
    onFailure: (error: any) => void;
  };
}

function* removeServiceTemplateSaga({ payload: { serviceId, onSuccess, onFailure } }: removeServiceTemplateSagaProp) {
  try {
    // @ts-ignore
    const token = yield select(state => state.auth.token);
    // @ts-ignore
    const response = yield call<any>(API.delete, `/service-templates/${serviceId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    yield put(removeServiceTemplateSuccess(response.data));
    onSuccess();
  } catch (error: any) {
    yield errorHandler({
      error,
      *recallCallback() {
        yield removeServiceTemplateSaga({
          payload: { serviceId, onSuccess, onFailure },
        });
      },
      *callback() {
        yield put(removeServiceTemplateFailure(error));
        onFailure(error);
      },
    });
  }
}

// Watcher Saga
export function* serviceTemplatesSaga() {
  // @ts-ignore
  yield takeLatest(getServiceTemplates().type, getServiceTemplatesSaga);
  // @ts-ignore
  yield takeLatest(getFilteredServiceTemplates().type, getFilteredServiceTemplatesSaga);
  // @ts-ignore
  yield takeLatest(createServiceTemplate().type, createServiceTemplateSaga);
  // @ts-ignore
  yield takeLatest(updateServiceTemplate().type, updateServiceTemplateSaga);
  // @ts-ignore
  yield takeLatest(removeServiceTemplate().type, removeServiceTemplateSaga);
}
